// import * as firebase from 'firebase/app';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/messaging';
import 'firebase/compat/functions';
import 'firebase/compat/analytics';
import 'firebase/compat/app-check';
// import { getAuth } from 'firebase/auth';
// import { getAnalytics } from 'firebase/analytics';
// import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

import { ANALYTICS_EVENT_PAGE_VIEW, AUTH_ERROR_CODE_REQUIRES_RECENT_LOGIN } from '../common/constants';

import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _forEach from 'lodash/forEach';
import { getEnvVariable } from '../common/envHelper';

export const devFirebaseConfig = {
    apiKey: 'AIzaSyDF2qOOm64lOzGmmWc10kEQRvfDkT9M0ME',
    authDomain: 'afitd-dev.firebaseapp.com',
    databaseURL: 'https://afitd-dev.firebaseio.com',
    projectId: 'afitd-dev',
    storageBucket: 'afitd-dev.appspot.com',
    messagingSenderId: '75392639764',
    appId: '1:75392639764:web:45dee57d704d47cc3fd801',
    measurementId: 'G-4H7REXPNCH',
};

export const testFirebaseConfig = {
    apiKey: 'AIzaSyCv3MOPfsK8XMqbGeFkFIyR4HER2il76Dc',
    authDomain: 'afitd-test.firebaseapp.com',
    databaseURL: 'https://afitd-test.firebaseio.com',
    projectId: 'afitd-test',
    storageBucket: 'afitd-test.appspot.com',
    messagingSenderId: '940492750139',
    appId: '1:940492750139:web:b734c12742ee7164ea0b1e',
    measurementId: 'G-J23DCYKJZR',
};

export const vendorFirebaseConfig = {
    apiKey: 'AIzaSyDtTBNOvoMPGVCihm7rcpCPm9YhKl9X-8U',
    authDomain: 'abyss-vendor-b829d.firebaseapp.com',
    databaseURL: 'https://abyss-vendor-b829d.firebaseio.com',
    projectId: 'abyss-vendor-b829d',
    storageBucket: 'abyss-vendor-b829d.appspot.com',
    messagingSenderId: '748741012118',
    appId: '1:748741012118:web:f42df2d9c0902ee842b0b7',
    measurementId: 'G-NKXYW7GGSF',
};

export const prodFirebaseConfig = {
    apiKey: process.env.REACT_APP_PROD_FIREBASE_API_KEY_PROD,
    authDomain: process.env.REACT_APP_PROD_FIREBASE_AUTH_DOMAIN_PROD,
    projectId: process.env.REACT_APP_PROD_FIREBASE_PROJECT_ID_PROD,
    storageBucket: process.env.REACT_APP_PROD_FIREBASE_STORAGE_BUCKET_PROD,
    messagingSenderId: process.env.REACT_APP_PROD_FIREBASE_MESSAGING_SENDER_ID_PROD,
    appId: process.env.REACT_APP_PROD_FIREBASE_APP_ID_PROD,
    measurementId: process.env.REACT_APP_PROD_FIREBASE_MEASUREMENT_ID_PROD,
};

// const firebaseApp = firebase.initializeApp(firebaseConfig);

// export default firebaseApp;

export const initFirebaseAuth = setAuth => {
    fetch('/__/firebase/init.json')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(json => {
            console.log('>>>>>>>>>>>>>>>>> firebase config: ', json);
            firebase.initializeApp(json);
            setAuth(firebase.auth());
            firebase.analytics();
            // setAuth(getAuth());
            // getAnalytics(app);

            try {
                // Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise site key and pass it to activate().
                const appCheck = firebase.appCheck();
                appCheck.activate(
                    new firebase.appCheck.ReCaptchaEnterpriseProvider(getEnvVariable('APP_CHECK_RECAPTCHA_SITE_KEY')),
                    true, // Set to true to allow auto-refresh.
                );

                // // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
                // // key is the counterpart to the secret key you set in the Firebase console.
                // const appCheck = initializeAppCheck(app, {
                //     provider: new ReCaptchaV3Provider('6Lf6PRIiAAAAAG0LSDVKYQczPD5SFEa7TmM6A1fA'),

                //     // Optional argument. If true, the SDK automatically refreshes App Check
                //     // tokens as needed.
                //     isTokenAutoRefreshEnabled: true,
                // });
            } catch (error) {
                console.error('Failed to initialize App Check.');
            }
        })
        .catch(error => {
            console.error('There has been a problem with your fetch operation:', error);
        });
};

export const initFirebaseAuthLocal = setAuth => {
    const firebaseConfig =
        process.env.REACT_APP_ENV === 'DEV'
            ? devFirebaseConfig
            : process.env.REACT_APP_ENV === 'TEST'
            ? testFirebaseConfig
            : process.env.REACT_APP_ENV === 'VENDOR'
            ? vendorFirebaseConfig
            : process.env.REACT_APP_ENV === 'PROD' && process.env.NODE_ENV === 'development'
            ? prodFirebaseConfig
            : testFirebaseConfig;
    firebase.initializeApp(firebaseConfig);
    setAuth(firebase.auth());
    firebase.analytics();
    // setAuth(getAuth());
    // getAnalytics(app);

    try {
        // Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise site key and pass it to activate().
        const appCheck = firebase.appCheck();
        appCheck.activate(
            new firebase.appCheck.ReCaptchaEnterpriseProvider(getEnvVariable('APP_CHECK_RECAPTCHA_SITE_KEY')),
            true, // Set to true to allow auto-refresh.
        );

        // // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
        // // key is the counterpart to the secret key you set in the Firebase console.
        // const appCheck = initializeAppCheck(app, {
        //     provider: new ReCaptchaV3Provider('6Lf6PRIiAAAAAG0LSDVKYQczPD5SFEa7TmM6A1fA'),

        //     // Optional argument. If true, the SDK automatically refreshes App Check
        //     // tokens as needed.
        //     isTokenAutoRefreshEnabled: true,
        // });
    } catch (error) {
        console.error('Failed to initialize App Check.');
    }
};

export const getCloudStorage = () => {
    return firebase.storage();
};

export const getFirestore = () => {
    const db = firebase.firestore();
    // if (window.location.hostname === 'localhost') db.settings({ host: 'localhost:8080', ssl: false });
    return db;
};

export const getFirestoreDeleteField = () => {
    return firebase.firestore.FieldValue.delete();
};

export const getGeoPoint = (lat, long) => {
    return new firebase.firestore.GeoPoint(lat, long);
};

export const getArrayUnion = data => {
    return firebase.firestore.FieldValue.arrayUnion(data);
};

export const getArrayRemove = data => {
    return firebase.firestore.FieldValue.arrayRemove(data);
};

export const getFirestoreIncrementField = incValue => {
    return firebase.firestore.FieldValue.increment(incValue);
};

export const getFirebaseMessageToken = async setTokenFound => {
    const messaging = firebase.messaging();

    return messaging
        .getToken({ vapidKey: 'BNkxyz8hX5SV_9cG1MiQXslNYMCTQvHk6tMxX035AlFMovM8Ijnz5d9_rbq1QdeanMnVsBXAfK8gAv5oT4yqfG8' })
        .then(currentToken => {
            if (currentToken) {
                console.log('current token for client: ', currentToken);
                setTokenFound(true);
            } else {
                console.log('No registration token available. Request permission to generate one.');
                setTokenFound(false);
            }
        })
        .catch(err => {
            console.log('An error occurred while retrieving token. ', err);
        });
};

export const unsubscribeRealtimeUpdates = unsubscribeList => {
    _forEach(_isArray(unsubscribeList) ? unsubscribeList : [unsubscribeList], unsubscribe => {
        if (unsubscribe) {
            unsubscribe();
        }
    });
};

export const getFirebaseAuth = () => {
    return firebase.auth();
    // return getAuth();
};

export const getFirebaseEmailAuthProvider = () => {
    return firebase.auth.EmailAuthProvider;
    // return getAuth().EmailAuthProvider;
};

export const getFirebaseAppleAuthProvider = () => {
    return new firebase.auth.OAuthProvider('apple.com');
};

export const getFirebaseFacebookAuthProvider = () => {
    return new firebase.auth.FacebookAuthProvider();
};

export const getFirebaseTwitterAuthProvider = () => {
    return new firebase.auth.TwitterAuthProvider();
};

export const getFirebaseGoogleAuthProvider = () => {
    return new firebase.auth.GoogleAuthProvider();
};

export const getAnalytics = () => {
    return firebase.analytics();
};

export const logEvent = (eventName, eventParams = {}) => {
    const analytics = getAnalytics();
    analytics.logEvent(eventName, eventParams);
};

export const logPageView = (pageTitle = getEnvVariable('AFITD_SITE_NAME'), eventParams = {}) => {
    const analytics = getAnalytics();
    analytics.logEvent(ANALYTICS_EVENT_PAGE_VIEW, { page_title: pageTitle, ...eventParams });
};

export const getCloudFunctions = () => {
    const functions = firebase.functions();
    // if (process.env.NODE_ENV === 'development') functions.useEmulator('localhost', 5001);
    return functions;
};

export const deleteUser = async () => {
    try {
        const auth = getFirebaseAuth();
        const authUser = auth.currentUser;
        const userId = authUser.uid;

        await authUser.delete();

        return userId;
        ////
    } catch (authError) {
        const code = _get(authError, 'code');
        console.log('Failed to delete user.', authError);
        if (code === AUTH_ERROR_CODE_REQUIRES_RECENT_LOGIN) throw new Error(AUTH_ERROR_CODE_REQUIRES_RECENT_LOGIN);
        else return null;
    }
};
